
import React, { useState, useEffect } from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Loader2, CheckCircle, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface FormActionsProps {
  saving: boolean;
  saveSuccess: boolean;
  onSave: () => void;
  hasChanges?: boolean;
  className?: string;
}

const FormActions: React.FC<FormActionsProps> = ({ 
  saving, 
  saveSuccess, 
  onSave,
  hasChanges = true,
  className
}) => {
  const { t } = useTranslationUtils();
  const [showSuccess, setShowSuccess] = useState(false);
  
  // Reset success message after a delay
  useEffect(() => {
    if (saveSuccess) {
      setShowSuccess(true);
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [saveSuccess]);

  return (
    <div className={cn("flex justify-between w-full items-center", className)}>
      <div className="text-sm text-muted-foreground">
        {showSuccess && (
          <div className="flex items-center text-green-600">
            <CheckCircle className="w-4 h-4 mr-1" />
            {t('admin.settingsSaved', 'Settings saved successfully')}
          </div>
        )}
      </div>
      <Button onClick={onSave} disabled={saving || !hasChanges}>
        {saving ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {t('admin.saving', 'Saving...')}
          </>
        ) : (
          t('admin.saveSettings', 'Save Settings')
        )}
      </Button>
    </div>
  );
};

export default FormActions;
